export const DYNAMIC_BANNER = 'dynamic-banner';
